import {
  Box,
  Button,
  Center,
  Flex,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { toFixedWithoutRounding } from "@constants/common";
import useDappConfig from "@hooks/useDappConfig";
import useWithdrawals from "@hooks/useWithdrawals";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import moment from "moment";
import { formatEther } from "viem";
import { useAccount, useBlockNumber, useSwitchChain } from "wagmi";
// import { useState } from "react";

const enum TabTypes {
  ACTIVE = "active",
  COMPLETED = "completed",
}

const tabs = [
  { key: TabTypes.ACTIVE, label: "Active", isLive: true },
  { key: TabTypes.COMPLETED, label: "Completed", isLive: false },
];

const Withdraw = () => {
  const { data: blockNumber } = useBlockNumber({
    query: { refetchInterval: 10_000 },
  });
  const { isConnected } = useAccount();

  const { switchChain } = useSwitchChain();
  const { openConnectModal } = useConnectModal();

  const { isWithdrawSupported, withdrawEnabledChains } = useDappConfig();
  //   const [tabIndex, setTabIndex] = useState(0);

  const {
    userWithdrawals,
    isFetching,
    // refetchAssociatedNonces
  } = useWithdrawals();

  return (
    <Box pos="relative">
      <Box
        pos="relative"
        pointerEvents={isWithdrawSupported || !isConnected ? "all" : "none"}
        filter="auto"
        blur={isWithdrawSupported || !isConnected ? "0" : "3px"}
      >
        {userWithdrawals.length ? (
          <Tabs
            align="center"
            variant="unstyled"
            // onChange={(index) => setTabIndex(index)}
          >
            <TabList
              mb="1em"
              border="1px solid #B6DFDF"
              borderRadius="12px"
              overflow={"hidden"}
              padding={1}
              w="fit-content"
              justifySelf="center"
            >
              {tabs.map((tab) => (
                <Tab
                  key={`${tab.key}-tab`}
                  borderRadius="8px"
                  padding={"8px 16px"}
                  fontSize={14}
                  fontWeight="600"
                  _selected={{ color: "white", bg: "#075A5A" }}
                >
                  {tab.label}
                </Tab>
              ))}
            </TabList>
            <TabPanels w="100%">
              {tabs.map((tab) => (
                <TabPanel h={377} key={`${tab.key}-panel`} textAlign="left">
                  {tab.key === TabTypes.ACTIVE && (
                    <Box>
                      <Text
                        fontSize={{ base: 10, lg: 12 }}
                        fontWeight="700"
                        mb={6}
                      >
                        AMOUNT
                      </Text>
                      {userWithdrawals.map((withdrawal) => {
                        const isClaimable =
                          Number(blockNumber) >
                          withdrawal.unlockedOnBlockNumber;

                        const duration =
                          (withdrawal.unlockedOnBlockNumber -
                            Number(blockNumber)) *
                          12;

                        const durationText = moment.duration(
                          duration,
                          "seconds"
                        );
                        return (
                          <Flex
                            mb={6}
                            key={`${withdrawal.asset}-${withdrawal.startTime}`}
                            justify="space-between"
                            alignItems="center"
                          >
                            <Text fontSize={{ base: 14, lg: 16 }}>
                              {
                                +toFixedWithoutRounding(
                                  formatEther(withdrawal.expectedAssetAmount),
                                  6
                                )
                              }{" "}
                              {withdrawal.symbol}
                            </Text>
                            {isClaimable && (
                              <Button
                                size="md"
                                padding={"8px 16px"}
                                bg="textPrimary"
                                _hover={{
                                  bg: "textPrimary",
                                }}
                                fontWeight="600"
                                color="backgroundCard"
                                fontSize={12}
                              >
                                Claim
                              </Button>
                            )}
                            {!isClaimable && (
                              <Text fontSize={{ base: 14, lg: 16 }}>
                                ~in {durationText.humanize()}
                              </Text>
                            )}
                          </Flex>
                        );
                      })}
                    </Box>
                  )}
                  {tab.key === TabTypes.COMPLETED && (
                    <Box textAlign="center" py={10}>
                      <Text fontSize={24} fontWeight="600">
                        Coming soon!
                      </Text>
                    </Box>
                  )}
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        ) : isConnected ? (
          <Center
            h={isWithdrawSupported ? 440 : 336}
            flexDir="column"
            textAlign="center"
            gap={4}
          >
            {isFetching ? (
              <Spinner size="md" color="primary" />
            ) : (
              <>
                <Text fontSize={{ base: 18, lg: 24 }} fontWeight="600">
                  No unstake requests found
                </Text>
                <Text fontSize={{ base: 14, lg: 16 }}>
                  You will be able to claim your tokens after the Unstake
                  request has been processed. To Unstake your tokens go to
                  Unstake tab
                </Text>
              </>
            )}
          </Center>
        ) : (
          <Center
            h={isWithdrawSupported ? 440 : 336}
            flexDir="column"
            textAlign="center"
            gap={4}
          >
            <Text fontSize={24} fontWeight="600">
              Connect your wallet
            </Text>
            <Text>
              You will be able to claim your tokens after you connect your
              wallet
            </Text>
          </Center>
        )}
      </Box>
      {!isWithdrawSupported && isConnected && (
        <Button
          borderRadius="12px"
          bg="textPrimary"
          p="16px 64px"
          h="56px"
          mt="12px"
          width="100%"
          _hover={{
            bg: "textPrimary",
          }}
          onClick={() => switchChain({ chainId: withdrawEnabledChains[0].id })}
        >
          <Text
            fontSize="16px"
            lineHeight="24px"
            fontWeight="600"
            color="backgroundCard"
          >
            {`Switch to ${withdrawEnabledChains[0].name} to Withdraw`}
          </Text>
        </Button>
      )}
      {!isConnected && (
        <Button
          borderRadius="12px"
          bg="textPrimary"
          p="16px 64px"
          h="56px"
          mt="12px"
          width="100%"
          _hover={{
            bg: "textPrimary",
          }}
          onClick={openConnectModal}
        >
          <Text
            fontSize="16px"
            lineHeight="24px"
            fontWeight="600"
            color="backgroundCard"
          >
            Connect Wallet
          </Text>
        </Button>
      )}
    </Box>
  );
};

export default Withdraw;
